import { createContext, PropsWithChildren, useContext, useState } from 'react';

import { K8sProvider } from '@cast/shared-types';

type UploadCommitmentsContextState = {
  provider?: K8sProvider;
  autoEnable?: boolean;
  setAutoEnable: (autoEnable: boolean) => void;
};

const UploadCommitmentsContext = createContext<UploadCommitmentsContextState>({
  provider: undefined,
  autoEnable: undefined,
  setAutoEnable: () => {},
});

type Props = {
  provider?: K8sProvider;
};

export const UploadCommitmentsProvider = ({
  children,
  provider,
}: PropsWithChildren<Props>) => {
  const [previousProvider, setPreviousProvider] = useState<
    K8sProvider | undefined
  >();
  const [autoEnable, setAutoEnable] = useState<boolean | undefined>(undefined);

  if (previousProvider !== provider) {
    setPreviousProvider(provider);
    if (!provider) {
      setAutoEnable(undefined);
    } else {
      setAutoEnable(true);
    }
  }

  return (
    <UploadCommitmentsContext.Provider
      value={{
        provider,
        autoEnable,
        setAutoEnable,
      }}
    >
      {children}
    </UploadCommitmentsContext.Provider>
  );
};

export const useUploadCommitmentsContext = () => {
  const context = useContext(UploadCommitmentsContext);
  if (!context) {
    throw new Error(
      'useUploadCommitmentsContext must be used within a UploadCommitmentsProvider'
    );
  }
  return context;
};
